import { createSelector } from 'reselect';

const selectHeaderData = ({ marketConfigReducer: { response: { headerData } = {} } = {} }) => headerData;

export const selectHeader = createSelector(selectHeaderData, ({ header: { fields = {} } = {}, disposition } = {}) => ({
  fields,
  disposition,
}));
